import script from "./Co2QuizMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./Co2QuizMenu.vue?vue&type=script&lang=ts&setup=true"

import "./Co2QuizMenu.vue?vue&type=style&index=0&id=4a21f2c2&lang=css"

const __exports__ = script;

export default __exports__